import { z } from 'zod';

/**
 * Device platforms. iOS, Windows and macOS are listed now so agents for them can be
 * added later without a server change.
 */
export const DeviceType = z.enum(['android', 'linux', 'ios', 'windows', 'macos', 'other']);
export type DeviceType = z.infer<typeof DeviceType>;

/** Things an agent can do. Unknown future capabilities are accepted and passed through. */
export const KNOWN_CAPABILITIES = ['ring', 'lost_mode', 'lost_mode_fullscreen', 'locate_now'] as const;
export const Capabilities = z
  .array(z.string().regex(/^[a-z][a-z0-9_]{0,39}$/))
  .max(20)
  .transform((caps) => [...new Set(caps)]);

/** Free-form platform details (OS, version, model), kept small. */
export const PlatformInfo = z
  .record(z.string().min(1).max(40), z.string().max(200))
  .refine((info) => Object.keys(info).length <= 20, 'At most 20 platform fields.');
export type PlatformInfo = z.infer<typeof PlatformInfo>;

export const DeviceName = z.string().trim().min(1, 'Give the device a name.').max(60);

/** API timestamps are ISO 8601 in UTC; the UI shows them in Europe/London. */
export const IsoDateTime = z.iso.datetime();

export const Id = z.uuid();

/** The error body every non-2xx API response uses. */
export const ApiError = z.object({
  error: z.object({
    code: z.string(),
    message: z.string(),
  }),
});
export type ApiError = z.infer<typeof ApiError>;
